<template>
  <div class="container-fluid p-0 h-100 ">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">Orden de recogida</p>
    </div>
    <div class="docs-box-scroll">
      <div class="docs-list" v-if = !showDataBlockChain>
        <DocumentDetail 
          v-for="(document, index) in documents" :key="index"
          v-bind:name="document.name"
          v-bind:docURL="document.docURL"
          v-bind:block_chain="document.block_chain"
        ></DocumentDetail>
      </div>
      <div class="data-block-chain" v-else>
         <DataBlockChain 
        ></DataBlockChain>
      </div>
    </div>
    <OrderDetail></OrderDetail>
    <ocrInput name="truck"></ocrInput>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DocumentDetail from '@/components/containerViews/containerDocsComponets/DocumentDetail'
import DataBlockChain from '@/components/containerViews/containerDocsComponets/DataBlockChain'
import OrderDetail from '@/components/OrderDetail'
import ocrInput from '@/components/ocrScan/ocrInput'


export default {
  name: 'PickupOrder',
  components: {
    DocumentDetail,
    DataBlockChain,
    OrderDetail,
    ocrInput
  },
  data(){
    return {
        showDataBlockChain: false,
        documents: [
          {
            name: 'Entréguese',
            docURL: '',
            block_chain: ''
          },
        ]
     }
  },
  computed: {
    ...mapGetters(["view_role"]),  
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      user: 'user'
    }),
    ...mapGetters("container",{
      container_id: 'container_id',
    }),
  },
  mounted () {
    this.getDocuments()
  },
  methods: {
    getDocuments: function () {

    }
  }
}
</script>

<style lang= "scss" scoped>

.docs-container {
  position: absolute;
  width:100%;
  bottom: 30px;
  top:151px;
  display: flex;
  flex-direction: column;
}
.docs-box-scroll {
  overflow: auto;
  /* margin: 12px; */
  flex: 1;
  /* border-top: 1px solid lightgray; 
  padding-top: 10px;  */
}

.data-block-chain {
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  margin: 1.2rem;
}


</style>
